import isEmpty from 'lodash/isEmpty';
import type {
	Extension,
	ForgeUIType,
} from '@atlassian/jira-forge-ui-types/src/common/types/extension.tsx';

export const getForgeUIType = (extension: Extension, entryPoint = ''): ForgeUIType => {
	const { render, resource } = extension.properties;

	if (entryPoint && extension.properties[entryPoint]) {
		const { resource: entryPointResource, render: entryPointRender } =
			extension.properties[entryPoint];

		if (entryPointResource == null) {
			return 'ui-kit';
		}
		if (entryPointRender === 'native') {
			return 'native-ui';
		}
		return 'custom-ui';
	}

	if (resource == null) {
		return 'ui-kit';
	}
	if (render === 'native') {
		return 'native-ui';
	}
	return 'custom-ui';
};

export const isCustomUIExtension = (extension: Extension, entryPoint = '') =>
	getForgeUIType(extension, entryPoint) === 'custom-ui';

export const isNativeUiExtension = (extension: Extension, entryPoint = '') =>
	getForgeUIType(extension, entryPoint) === 'native-ui';

export const overrideExtension = <E extends Extension>(
	extension: E,
	propsToOverride: {
		resource?: string;
	},
): E => {
	if (extension == null) return extension;
	if (isEmpty(propsToOverride)) return extension;

	const { resource } = propsToOverride;

	// We must also spread `extension.properties` because JS doesn't deep-copy objects.
	// Only spreading `extension` will result in `resource` on the original `extension`
	// object being modified.
	// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
	const extensionCopy: E = {
		...extension,
		properties: {
			...extension.properties,
		},
	} as any; // eslint-disable-line @typescript-eslint/no-explicit-any

	if (resource != null) {
		extensionCopy.properties.resource = resource;
	}
	return extensionCopy;
};
